import { PropType, reactive, ref } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import { ORDER_DASHBOARD_FILTER } from '@/typings/enums/ORDER_DASHBOARD_FILTER';
import { USER_TYPE } from '@/typings/enums/USER_TYPE';

type Props = SetupProps<typeof OrderDashboardHomeOrderItemSetupService.props>

export default class OrderDashboardHomeOrderItemSetupService extends BaseSetupService<Props> {
	static readonly props = {
		autoExpand: Boolean,
		orderItem: {
			type: Object as PropType<IOrderDashboardItemModel>,
			required: true as const,
		},
	};

	readonly _history = ref<HTMLElement>();

	private readonly state = reactive({
		expand: false,
		historyHeight: 0,
	});

	get expand () { return this.state.expand; }
	get historyHeight () { return this.state.historyHeight; }

	get daysOffset () {
		const orderStartIsPassed = new Date(this.props.orderItem.start).getTime() - new Date().getTime() < 0;
		const daysOffset = orderStartIsPassed
			? new Date(this.props.orderItem.start).getTimeBetween()
			: new Date().getTimeBetween(undefined, new Date(this.props.orderItem.start));
		return daysOffset;
	}

	get orderStatusType () {
		if (this.props.orderItem.type === ORDER_DASHBOARD_FILTER.New) {
			return {
				color: 'info' as Orion.Color,
				label: 'Nouvelle',
			};
		} else if (this.props.orderItem.type === ORDER_DASHBOARD_FILTER.Urgent) {
			return {
				color: 'warning' as Orion.Color,
				label: 'Urgente',
			};
		} else return null;
	}

	get creator () {
		if (this.props.orderItem.creatorUserUserType === USER_TYPE.Client) {
			return {
				name: this.props.orderItem.clientCompanyName,
				city: this.props.orderItem.clientCompanyContactDetailCity,
			};
		} else {
			return {
				name: this.props.orderItem.agencyCompanyName,
				city: this.props.orderItem.agencyCompanyContactDetailCity,
			};
		}
	}

	get orderFor () {
		if (this.props.orderItem.creatorUserUserType === USER_TYPE.Client) {
			return {
				name: this.props.orderItem.agencyCompanyName,
				city: this.props.orderItem.agencyCompanyContactDetailCity,
			};
		} else {
			return {
				name: this.props.orderItem.clientCompanyName,
				city: this.props.orderItem.clientCompanyContactDetailCity,
			};
		}
	}

	get orderhistoriesSorted () {
		return this.props.orderItem.histories.map(x => x).sort((a, b) => b.id - a.id);
	}

	constructor (props?: Props) {
		super(props);
	}

	protected onMounted () {
		this.state.historyHeight = this._history.value?.scrollHeight ?? 0;

		if (this.props.autoExpand) {
			setTimeout(() => {
				this.state.expand = true;
			}, 700);
		}
	}

	toggleExpandLastActivity () {
		if (!this.props.orderItem.histories.length) return;
		this.state.expand = !this.expand;
	}

	gotToOrder (id:number) {
		this.router.push({
			name: 'OrderDetails',
			params: { orderId: id },
		});
	}
}
